import { Icon, IconNames } from '@triumph/design-system';
import React from 'react';
import {
    AppliedChip,
    AppliedChipRemoveButton,
    ChipListInline,
    ChipListStacked,
    OverflowChip,
} from './FilterDrawer.styles';

export interface AppliedFilterChipProps {
    id: string;
    label: string;
    index: number;
    onRemove: (id: string) => void;
}

export function AppliedFilterChip({ id, label, index, onRemove }: AppliedFilterChipProps) {
    return (
        <AppliedChip
            role="listitem"
            data-testid={`applied-filter-chip-${id}`}
            style={{ '--chip-index': index } as React.CSSProperties}
        >
            {label}
            <AppliedChipRemoveButton
                type="button"
                aria-label={`Remove filter: ${label}`}
                onClick={() => onRemove(id)}
            >
                <Icon name={IconNames.Danger_CloseX} size={12} id={`remove-${id}`} />
            </AppliedChipRemoveButton>
        </AppliedChip>
    );
}

export interface AppliedFilterChipsProps {
    filters: Array<{ id: string; label: string }>;
    onRemove: (id: string) => void;
    layout: 'stacked' | 'inline';
    overflow?: number;
    onOverflowClick?: () => void;
}

export function AppliedFilterChips({ filters, onRemove, layout, overflow, onOverflowClick }: AppliedFilterChipsProps) {
    const List = layout === 'stacked' ? ChipListStacked : ChipListInline;

    const visibleFilters = overflow !== undefined && filters.length > overflow ? filters.slice(0, overflow) : filters;
    const overflowCount = overflow !== undefined ? filters.length - overflow : 0;

    return (
        <List role="list">
            {visibleFilters.map((f, i) => (
                <AppliedFilterChip key={f.id} id={f.id} label={f.label} index={i} onRemove={onRemove} />
            ))}
            {overflowCount > 0 && (
                <OverflowChip
                    data-testid="applied-filter-overflow"
                    aria-label={`Show ${overflowCount} more filters`}
                    onClick={onOverflowClick}
                    style={{ '--chip-index': visibleFilters.length } as React.CSSProperties}
                >
                    +{overflowCount} more
                </OverflowChip>
            )}
        </List>
    );
}
